<div class="tw-bg-[#F5F4F4] tw-rounded-[10px] sm:tw-rounded-[24px] tw-p-6">
    <div class="tw-flex tw-justify-end">
        <mat-icon
            ga-event-id="x_button_no_product_match_popup_click"
            ga-event-category="No Product Match Popup Button"
            ga-event-label="X Button Submit Click"
            ga-track="track"
            [mat-dialog-close]
            class="tw-cursor-pointer"
            >close</mat-icon
        >
    </div>
    <div
        class="tw-mt-2 tw-text-center tw-text-[18px] tw-text-[#3D3D3D] tw-font-bold"
    >
        <div>
            {{ "PRODUCT_MATCHING.REMINDER_POPUP.REMINDER" | translate }}
        </div>
        <div class="tw-mt-3">
            {{ "PRODUCT_MATCHING.REMINDER_POPUP.REMINDER_MESS" | translate }}
        </div>
    </div>
    <div
        class="tw-mt-8 tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-evenly tw-gap-4"
    >
        <button
            ga-event-id="add_more_button_no_product_match_popup_click"
            ga-event-category="No Product Match Popup Button"
            ga-event-label="Add More Button Main Button Submit Click"
            ga-track="track"
            (click)="addMore()"
            class="tw-py-3 tw-px-14 tw-text-[16px] tw-font-medium tw-text-[#FFA53C] tw-bg-white tw-border tw-border-[#FFA53C] tw-rounded-full"
        >
            {{ "PRODUCT_MATCHING.REMINDER_POPUP.ADD_MORE" | translate }}
        </button>
        <button
            ga-event-id="continue_button_no_product_match_popup_click"
            ga-event-category="No Product Match Popup Button"
            ga-event-label="Continue Button Main Button Submit Click"
            ga-track="track"
            (click)="onContinue()"
            class="tw-py-3 tw-px-14 tw-text-[16px] tw-font-medium tw-text-white tw-bg-[#FFA53C] tw-rounded-full"
        >
            {{ "PRODUCT_MATCHING.REMINDER_POPUP.CONTINUE" | translate }}
        </button>
    </div>
</div>
